import React from "react";

/** Content languages; option values are "<language> <code>". */
export const LANGUAGES = [
  { value: "english en", label: "English" },
  { value: "french fr", label: "French" },
  { value: "polski pl", label: "Polski" },
  { value: "italiano it", label: "Italiano" },
  { value: "espanol es", label: "Espanol" },
  { value: "duetsch de", label: "Duetsch" },
];

/** `<option>`s of the content languages, to put in a language `<select>`. */
const LanguageOptions = () =>
  LANGUAGES.map(({ value, label }) => (
    <option value={value} key={value}>
      {label}
    </option>
  ));

export default LanguageOptions;
